import type { RingFinish, RingStyle } from '@/app/types/ring';
import { useFeatureFlag } from '@/queries/FeaturesConfig';

export interface UseDefaultPdpSelectionsState {
  finish: RingFinish;
  style: RingStyle;
}

export const DEFAULT_SELECTION: UseDefaultPdpSelectionsState = {
  finish: 'silver',
  style: 'heritage',
};

// This is where you can add feature flags to use alternate default selections
const useDefaultPdpSelections = (): UseDefaultPdpSelectionsState => {
  const enableHeritagePDPDefault = useFeatureFlag('pdp-heritage-default');
  const enableHeritageGoldDefault = useFeatureFlag('pdp-default-heritage-gold');

  if (enableHeritageGoldDefault) {
    return {
      finish: 'gold',
      style: enableHeritagePDPDefault ? 'heritage' : 'horizon',
    };
  }

  return DEFAULT_SELECTION;
};

export default useDefaultPdpSelections;
